import { render, staticRenderFns } from "./Charger.vue?vue&type=template&id=486e8454"
import script from "./Charger.vue?vue&type=script&lang=js"
export * from "./Charger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports